import './wdyr';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import 'normalize.css';
import { ModalProvider } from './components/Contexts/ModalContext';
import { AuthenticationProvider } from './components/Contexts/AuthenticationContext';
import PrivateRoute from './components/Routing/PrivateRoute';
import { init } from '@sentry/browser';
import { initFontAwesome } from './initFontAwesome';
import ModalRoot from './components/Modals/ModalRoot';
import BusyIndicator from './components/Common/BusyIndicator';
import LoginPage from './components/Login/LoginPage';
import * as serviceWorker from './serviceWorker';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import theme from 'styled-theming';
import ErrorBoundary from './components/ErrorBoundary';
import HealthCheck from './components/HealthCheck/HealthCheck';
import PasswordResetPage from './components/ResetPassword/PasswordResetPage';
import ForgottenPasswordPage from './components/ForgottenPassword/ForgottenPasswordPage';
import VerifyLoginPage from './components/VerifyLogin/VerifyLoginPage';
import SessionExpiredPage from './components/SessionExpired/SessionExpiredPage';
import Themes from './styling/themes';

init({
  dsn: process.env.REACT_APP_SENTRY_DSN
});

initFontAwesome();

Modal.setAppElement('#root');

const backgroundColor = theme('mode', {
  light: Themes.light.backgroundColor,
  dark: Themes.dark.backgroundColor,
  custom: Themes.custom.backgroundColor
});

const color = theme('mode', {
  light: Themes.light.color,
  dark: Themes.dark.color,
  custom: Themes.custom.color
});

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    font-family: 'Roboto', sans-serif;
  }
  
  body {
    background-color: ${backgroundColor};
    color: ${color};
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    user-select: none;
  }
`;

const App = React.lazy(() =>
  import(/* webpackChunkName: "App" */ './components/App')
);

ReactDOM.render(
  <Router>
    <ErrorBoundary>
      <ThemeProvider theme={{ mode: 'light' }}>
        <Suspense fallback={<BusyIndicator text="Loading" size="5x" />}>
          <GlobalStyle />
          <HealthCheck>
            <ModalProvider>
              <ModalRoot />
              <AuthenticationProvider>
                <Switch>
                  <Route path="/login" component={LoginPage} />
                  <Route path="/verify" component={VerifyLoginPage} />
                  <Route path="/resetPassword" component={PasswordResetPage} />
                  <Route
                    path="/forgottenPassword"
                    component={ForgottenPasswordPage}
                  />
                  <Route
                    path="/sessionExpired"
                    component={SessionExpiredPage}
                  />
                  <PrivateRoute path="/" component={App} />
                </Switch>
              </AuthenticationProvider>
            </ModalProvider>
          </HealthCheck>
        </Suspense>
      </ThemeProvider>
    </ErrorBoundary>
  </Router>,
  document.getElementById('root')
);

serviceWorker.register();
